import { useEffect, useMemo, useRef, useState } from "react";
import { useLiveStateSyncUtils } from "./LiveStateSyncElement";
export function useLiveStateSyncEventCallback(action) {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.on, memoizedAction]);
    return data;
}
